<!-- -----WIDOK DESKTOP----- -->

<ion-row class="content color-black" *ngIf="!displayMobileView">
  <ion-col size="1">
    <img
      class="user-assignment-view__image"
      [ngClass]="{ 'user-assignment-view__image--plug': !row.space.image }"
      [src]="row.space.image ? row.space.image.filePath : spacePlug"
    />
  </ion-col>
  <ion-col size="1"> {{ row.space.floor.building.name }}</ion-col>
  <ion-col size="1">
    {{ row.space.floor.name }}
  </ion-col>
  <ion-col [size]="customData !== 'hidePlateNumber' ? '1' : '2'">
    {{ row.space.name }}
    <img
      *ngIf="row.space.subType"
      [src]="spaceService.searchSubtypeIcon(row.space.subType)"
      class="light"
    />
  </ion-col>
  <ion-col size="2">
    {{ row.dateFrom | dateSti }}
  </ion-col>
  <ion-col size="2">
    {{ row.dateTo | dateSti }}
  </ion-col>
  <ion-col
    size="1"
    *ngIf="
      customData !== 'hidePlateNumber' &&
      showBarierrButtonsAndRegistrationNumber
    "
  >
    {{ row.number }}
  </ion-col>
  <ion-col [size]="showBarierrButtonsAndRegistrationNumber ? '3' : '4'">
    <ng-container *ngIf="showBarrierButtonForPastAssignments">
      <ion-button
        class="ion-float-right"
        (click)="shareSpace()"
        *appHasRole="[permissionSpaceShare]"
      >
        {{ "SPACE.SHARE_SPACE" | translate }}
      </ion-button>
    </ng-container>
  </ion-col>
  <ion-col
    size="12"
    *ngIf="row.sharedAssignments.length > 0"
    class="user-assignment-view__shared-list-container"
    [@toggleHeight]="row.sharedAssignments.length > 0 ? 'active' : 'inactive'"
  >
    <ng-container *ngFor="let space of row.sharedAssignments">
      <div class="user-assignment-view__shared-container">
        <span class="user-assignment-view__shared-label">{{
          "SHARED" | translate
        }}</span>
        <span class="user-assignment-view__shared-date">
          <strong>
            {{ space.dateFrom | dateSti }}
          </strong>
          -
          <strong>
            {{ space.dateTo | dateSti }}
          </strong>
        </span>
        <span class="user-assignment-view__additional-information">
          {{ "SPACE.PLACE_SHARED_WITH_OTHER_USERS" | translate }}
        </span>
        <ng-container *ngIf="!space.bookings.length">
          <ion-button
            class="user-assignment-view__delete-shared-button"
            (click)="onEditSharedAssignment(space)"
            fill="clear"
            size="small"
          >
            <ion-icon src="../../../assets/icons/edit-pen.svg"></ion-icon>
          </ion-button>

          <ion-button
            class="user-assignment-view__delete-shared-button"
            (click)="onDeleteSharedAssignment(space)"
            fill="clear"
            size="small"
          >
            <ion-icon
              name="close"
              class="user-assignment-view__delete-shared-close-icon"
            ></ion-icon>
          </ion-button>
        </ng-container>
      </div>
      <div
        class="user-assignment-view__shared-container ion-margin-start"
        *ngFor="let booking of space.bookings"
      >
        <span
          class="user-assignment-view__shared-label user-assignment-view__shared-label--unavaliable"
          >{{ "UNAVAILABLE" | translate }}</span
        >
        <span class="user-assignment-view__shared-date">
          <strong>
            {{ booking.startTime | dateSti }}
          </strong>
          -
          <strong>
            {{ booking.endTime | dateSti }}
          </strong>
        </span>
        <span class="user-assignment-view__additional-information">
          {{ "SPACE.PLACE_OCCUPIED_BY" | translate }}:
          {{ booking.userOwner.firstName }}
        </span>
      </div>
    </ng-container>
  </ion-col>
</ion-row>

<!-- -----WIDOK MOBILNY----- -->

<ion-card
  *ngIf="displayMobileView"
  class="content-card-noborder user-assignment-view__mobile-container"
>
  <ion-card-header class="user-assignment-view__mobile-header">
    <div class="display-flex">
      <div>
        <ion-card-title>
          {{ spaceNameLabel }} {{ row.space.name }}
          <img
            class="user-assignment-view__mobile-icon light"
            *ngIf="row.space.subType"
            [src]="spaceService.searchSubtypeIcon(row.space.subType)"
          />
        </ion-card-title>
  
        <ion-card-subtitle>
          <ion-icon src="../../../assets/icons/building-alt.svg"></ion-icon>
          {{ row.space.floor.building.name }}
          <ion-icon name="layers-outline" class="margin-left-8 light"></ion-icon>
          {{ row.space.floor.name }}
        </ion-card-subtitle>
      </div>
  
      <div class="options-button" size="small" (click)="presentPopover($event)">
        <ion-icon slot="icon-only" name="ellipsis-horizontal"></ion-icon>
      </div>
    </div>
  </ion-card-header>

  <ion-card-content class="user-assignment-view__mobile-content">
    <ion-grid class="no-padding-grid booking-mobile">
      <ion-row
        *ngIf="
          (row.qrcode || barriers.length) &&
          showBarierrButtonsAndRegistrationNumber
        "
      >
        <ion-col class="user-assignment-view__mobile-barrier-header">
          <span></span>
          <div>{{ "SPACE.PARKING.OPEN_BARIERR" | translate }}</div>
          <span></span>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="showBarierrButtonsAndRegistrationNumber">
        <ion-col class="user-assignment-view__mobile-buttons-container">
          <!-- <ng-container *ngIf="!showButtonsLoader"> -->
          <!-- Przycisk wyłączamy dla showBarrierButtonForPastAssignments lub onLoadingDisable-->
          <!-- Natomiast dla aktualnie trwających udostępnień przycisk wygląda na wyłączony, ale da się go wcisnąć i pokazuje się popover. -->
          <ion-button
            *ngFor="let item of barriers"
            (click)="
              spaceIsNowShared ? spaceIsSharedInfo($event) : openBarrier(item)
            "
            class="user-assignment-view__mobile-open-button"
            [fill]="
              showBarrierButtonForPastAssignments && !spaceIsNowShared
                ? 'solid'
                : 'outline'
            "
            [disabled]="
              !showBarrierButtonForPastAssignments || onLoadingDisable
            "
            [ngClass]="{
              disabled: spaceIsNowShared
            }"
          >
            <ion-icon
              slot="start"
              [src]="
                item.key.includes('exit')
                  ? '../../../assets/icons/parking-exit.svg'
                  : '../../../assets/icons/parking-enter.svg'
              "
              [color]="
                showBarrierButtonForPastAssignments ? 'primary' : 'secondary'
              "
            ></ion-icon>
            <ion-text *ngIf="!p.renderSmallMobile">
              {{ onLoadingDisable ? barrierButtonText : exitButtonText(item) }}
            </ion-text>
            <ion-text *ngIf="!onLoadingDisable && p.renderSmallMobile">
              {{ exitButtonText(item) }}
            </ion-text>
            <ion-spinner *ngIf="onLoadingDisable" name="dots"></ion-spinner>
          </ion-button>
          <!-- </ng-container> -->
          <div
            *ngIf="row.qrcode"
            [ngClass]="{
              'user-assignment-view__button-container': !barriers.length
            }"
          >
            <ion-button
              fill="outline"
              class="user-assignment-view__mobile-generate-qr-button"
              [ngClass]="{
                'user-assignment-view__mobile-generate-qr-button--disabled':
                  !showBarrierButtonForPastAssignments || spaceIsNowShared
              }"
              [disabled]="
                !showBarrierButtonForPastAssignments || spaceIsNowShared
              "
              (click)="onQRCodePreview($event, row.qrcode.qrcodeValue)"
            >
              <ion-text
                class="user-assignment-view__button-text"
                *ngIf="!barriers.length"
              >
                {{ "SPACE.SHOW_QR" | translate }}
              </ion-text>
              <ion-icon
                slot="icon-only"
                src="../../../assets/icons/qr-code.svg"
              ></ion-icon>
            </ion-button>
          </div>
          <!-- <app-loading-sti *ngIf="showButtonsLoader"></app-loading-sti> -->
        </ion-col>
      </ion-row>
      <ion-row *ngIf="showBarierrButtonsAndRegistrationNumber">
        <ion-col class="user-assignment-view__mobile-details-container">
          <div>
            <ng-container *ngIf="row.number">
              <ion-icon
                src="../../../assets/icons/car.svg"
                class="margin-right-8"
              ></ion-icon>
              {{ row.number }}
            </ng-container>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="user-assignment-view__mobile-dates-label">
          <span>
            {{ "SPACE.DATE_FROM" | translate }}
          </span>
          <span>
            {{ "SPACE.DATE_TO" | translate }}
          </span>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          class="display-flex ion-align-items-center ion-justify-content-between"
        >
          <div
            class="user-assignment-view__mobile-dot user-assignment-view__mobile-dot--start"
          ></div>
          <div class="user-assignment-view__mobile-separator"></div>
          <div
            class="user-assignment-view__mobile-dot user-assignment-view__mobile-dot--end"
          ></div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="user-assignment-view__mobile-dates-container">
          <span>
            {{ row.dateFrom | dateSti }}
          </span>
          <span>
            {{ row.dateTo | dateSti }}
          </span>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ng-container *ngIf="row.sharedAssignments?.length > 0">
      <ion-button
        expand="block"
        fill="outline"
        shape="round"
        (click)="onToggleSharedSpaces()"
        class="user-assignment-view__mobile-show-shared-button"
      >
        {{ "SPACE.SHARING" | translate }} ({{
          row.sharedAssignments?.length
        }})
        <ion-icon
          slot="end"
          name="chevron-down-sharp"
          class="user-assignment-view__mobile-chevron-icon"
          [@toggleRotate]="showSharedSpaces ? 'active' : 'inactive'"
        ></ion-icon>
      </ion-button>
      <ion-grid
        *ngFor="let space of row.sharedAssignments"
        class="user-assignment-view__mobile-assignment-container"
        [ngClass]="{
          'user-assignment-view__mobile-assignment-container--action-buttons':
            space.bookings?.length == 0
        }"
        [@toggleHeight]="showSharedSpaces ? 'active' : 'inactive'"
      >
        <ion-row class="ion-no-padding">
          <ion-col
            class="display-flex ion-align-items-center ion-justify-content-between"
          >
            <div
              class="user-assignment-view__mobile-dot user-assignment-view__mobile-dot--start"
            ></div>
            <div class="user-assignment-view__mobile-separator"></div>
            <div
              class="user-assignment-view__mobile-dot user-assignment-view__mobile-dot--end"
            ></div>
          </ion-col>
        </ion-row>
        <ion-row class="ion-no-padding">
          <ion-col
            class="user-assignment-view__mobile-dates-container ion-padding-bottom"
          >
            <div>
              {{ space.dateFrom | dateSti }}
            </div>
            <div class="user-assignment-view__shared-label">
              {{ "SHARED" | translate }}
              <div
                class="user-assignment-view__mobile-assignment-button-container"
                *ngIf="space.bookings?.length == 0"
              >
                <ion-button
                  (click)="onEditSharedAssignment(space)"
                  fill="clear"
                  class="user-assignment-view__delete-shared-button"
                  size="small"
                >
                  <ion-icon
                    slot="icon-only"
                    src="../../../assets/icons/edit-pen.svg"
                    class="user-assignment-view__delete-shared-close-icon"
                  ></ion-icon>
                </ion-button>
                <ion-button
                  (click)="onDeleteSharedAssignment(space)"
                  fill="clear"
                  class="user-assignment-view__delete-shared-button"
                  size="small"
                >
                  <ion-icon slot="icon-only" name="close"></ion-icon>
                </ion-button>
              </div>
            </div>
            <div>
              {{ space.dateTo | dateSti }}
            </div>
          </ion-col>

          <ion-col size="12" *ngIf="space.bookings?.length > 0">
            <ion-grid
              *ngFor="let booking of space.bookings"
              class="ion-no-padding"
            >
              <ion-row class="ion-no-padding">
                <ion-col
                  class="display-flex ion-align-items-center ion-justify-content-between"
                >
                  <div
                    class="user-assignment-view__mobile-dot user-assignment-view__mobile-dot--start"
                  ></div>
                  <div class="user-assignment-view__mobile-separator"></div>
                  <div
                    class="user-assignment-view__mobile-dot user-assignment-view__mobile-dot--end"
                  ></div>
                </ion-col>
              </ion-row>
              <ion-row class="ion-no-padding">
                <ion-col
                  class="user-assignment-view__mobile-dates-container"
                  size="12"
                >
                  <span>
                    {{ booking.startTime | dateSti }}
                  </span>
                  <span
                    class="user-assignment-view__shared-label user-assignment-view__shared-label--unavaliable"
                    >{{ "UNAVAILABLE" | translate }}</span
                  >
                  <span>
                    {{ booking.endTime | dateSti }}
                  </span>
                </ion-col>
                <ion-col size="12">
                  <span
                    class="user-assignment-view__mobile-additional-information"
                  >
                    {{ "SPACE.PLACE_OCCUPIED_BY" | translate }}:
                    {{ booking.userOwner.firstName }}
                  </span>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ng-container>
  </ion-card-content>
</ion-card>
